import { styled } from '@mui/system';

export const Root = styled('a')({
  fontWeight: 800,
  textDecoration: 'none',
  '&:visited': {
    color: 'inherit',
  },
});
